
import React, { useContext, useEffect, useState } from 'react'
import AdminSideBar from '../../components/adminSideBar/AdminSideBar'
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import FormInput from '../../components/formInput/FormInput';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import { communes, wilayas } from '../../data';
import "./infoperson.css";
import { InfopersonContext } from '../../context/infopersonContext/InfopersonContext';
import { getInfoperson, updateInfoperson } from '../../context/infopersonContext/apiCalls';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';

export default function Infoperson() {
    const { dispatch, infoperson, message, isFetchingGet, errorGet, isFetchingUpdate, errorUpdate, } = useContext(InfopersonContext);
    const [errorInfoperson, setErrorInfoperson] = useState("");
    const [IsFetchingInfoperson, setIsFetchingInfoperson] = useState(false);

    const [username, setUsername] = useState("");
    const [agence, setAgence] = useState("");
    const [entreprise, setEntreprise] = useState("");
    const [role, setRole] = useState("");
    const [nom, setNom] = useState("");
    const [tel1, setTel1] = useState("");
    const [tel2, setTel2] = useState("");
    const [email, setEmail] = useState("");
    const [wilaya, setWilaya] = useState(wilayas[0]);
    const [commune, setCommune] = useState(communes[0][0]);

    useEffect(() => {
        if (errorGet !== false) {
            setErrorInfoperson(errorGet);
        }
        if (errorUpdate !== false) {
            setErrorInfoperson(errorUpdate);
        }
    }, [errorGet, errorUpdate]);

    useEffect(() => {
        setIsFetchingInfoperson(isFetchingGet || isFetchingUpdate);
    }, [isFetchingGet, isFetchingUpdate]);

    useEffect(() => {
        getInfoperson(dispatch);
    }, [message]);

    useEffect(() => {
        if (Object.keys(infoperson).length !== 0) {
            setUsername(infoperson.username);
            setAgence(infoperson.Agence ? infoperson.Agence.nom : "");
            setEntreprise(infoperson.Entreprise ? infoperson.Entreprise.nom : "");
            setRole(infoperson.Role.nom);

            setNom(infoperson.Userinfo.nom);
            setTel1(infoperson.Userinfo.tel1);
            setTel2(infoperson.Userinfo.tel2 || "");
            setEmail(infoperson.Userinfo.email);
            setWilaya(wilayas.filter(item => item.id === infoperson.Userinfo.wilaya)[0]);
            setCommune(communes[infoperson.Userinfo.wilaya].filter(item => item.id === infoperson.Userinfo.commune)[0]);
        }
    }, [infoperson])


    const updateInfopersonHandler = () => {
        if (nom.trim() == "") {
            setErrorInfoperson(`Vous devez compléter le Nom`);
            return;
        }
        if (tel1.trim() == "") {
            setErrorInfoperson(`Vous devez compléter le Téléphone`);
            return;
        }
        setErrorInfoperson('');
        updateInfoperson(dispatch, nom, tel1, tel2, email, wilaya.id, commune.id);
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="infoperson" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Infors :</span>
                </div>

                {
                    (errorGet || errorUpdate) ? <ErrorComponent error={errorInfoperson} /> : (
                        IsFetchingInfoperson ? <LoadingComponent /> : (
                            <div className="content infoperson">
                                <div className="box">
                                    <div className="box-title" style={{ marginBottom: "25px", }}>Infors Personnelles</div>
                                    {errorInfoperson !== "" && (<div style={{ marginBottom: "25px" }} className='box-error'>{errorInfoperson}</div>)}
                                    <div className="box-content">
                                        <FormInput label="Username" itemInput={username} setItemInput={setUsername} auth inactive />
                                        {
                                            infoperson.Agence && (
                                                <FormInput label="Agence" itemInput={agence} setItemInput={setAgence} auth inactive />
                                            )
                                        }
                                        {
                                            infoperson.Entreprise && (
                                                <FormInput label="Entreprise" itemInput={entreprise} setItemInput={setEntreprise} auth inactive />
                                            )
                                        }
                                        <FormInput label="Role" itemInput={role} setItemInput={setRole} auth inactive />
                                        <FormInput label="Nom" itemInput={nom} setItemInput={setNom} auth inactive />
                                        <DropDownComponent data={wilayas} itemChoisir={wilaya} setItemChoisir={setWilaya} inactive />
                                        <DropDownComponent data={communes[wilaya.id]} itemChoisir={commune} setItemChoisir={setCommune} inactive />
                                        <FormInput label="Tel1" itemInput={tel1} setItemInput={setTel1} auth inactive />
                                        <FormInput label="Tel2" itemInput={tel2} setItemInput={setTel2} auth inactive />
                                        <FormInput label="Email" itemInput={email} setItemInput={setEmail} auth inactive />
                                        {/* <div className='button' onClick={updateInfopersonHandler} style={isFetchingUpdate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                            <span>
                                                {isFetchingUpdate ? "Modifier ..." : "Modifier"}
                                            </span>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        )
                    )
                }
            </div>
        </div>
    )
}
